import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SearchFormBase } from '../../../../../components/common/search-form-base/search-form-base';
import { AppServiceHelperService } from '../../../../../services/app-service-helper.service';
import { EventBusService } from '../../../../../services/event-bus.service';

/**
 * Reports search form
 */
@Component({
  selector: 'reports-search-form',
  templateUrl: './reports-search-form.component.html',
  styleUrls: ['./reports-search-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportsSearchFormComponent extends SearchFormBase<any> implements OnInit {

  /**
  * Selected item type
  */
  @Input() selectedItemType: string;

  /**
  * Selected item
  */
  @Input() selectedItem: any;

  /**
   * Constructor
   * @param eventBus EventBusService
   * @param httpClient HttpClient
   * @param fb UntypedFormBuilder
   * @param appServiceHelper AppServiceHelperService
   */
  constructor(eventBus: EventBusService, httpClient: HttpClient, protected fb: UntypedFormBuilder, appServiceHelper: AppServiceHelperService) {
    super(eventBus, httpClient, 'resetValuationSearchMode', appServiceHelper);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.init().then(() => {
      //Nothing
    });
  }

  /**
   * Search event name (event bus)
   */
  protected get searchEventName(): string {
    return 'project.valuation.report.search';
  }

  /**
   * Show all event name (event bus)
   */
  protected get showAllEventName(): string {
    return 'project.valuation.report.showAll';
  }

  /**
   *
   * Gets the filter object
   * @param form
   * @returns
   */
  protected getFilterObject(form: UntypedFormGroup) {
    const filter = {
      logic: "and",
      filters: [],
      serverFilters: []
    };

    if (this.formData.controls.reportId.value) {
      filter.filters.push({ field: 'Oid', value: this.formData.controls.reportId.value, operator: "eq" });
    }
    if (this.formData.controls.valuer.value) {
      filter.filters.push({ field: 'ValuerIdDescription', value: this.formData.controls.valuer.value, operator: "contains" });
    }
    if (this.formData.controls.street.value) {
      filter.filters.push({ field: 'PropertyStreet', value: this.formData.controls.street.value, operator: "contains" });
    }
    if (this.formData.controls.community.value) {
      filter.filters.push({ field: 'PropertyMunicapelDescription', value: this.formData.controls.community.value, operator: "contains" });
    }
    if (this.selectedItemType === 'projectstd') {
      filter.filters.push({ field: 'ProjectStdIdDescription', value: this.selectedItem.Oid + ', ' + this.selectedItem.Name, operator: "contains" });
    }
    else if (this.formData.controls.puid.value) {
      filter.filters.push({ field: 'ProjectStdIdDescription', value: this.formData.controls.puid.value, operator: "contains" });
    }
    else if (this.selectedItemType === 'valuationPortfolio') {
      filter.filters.push({ field: 'ValuationProjectIdDescription', value: this.selectedItem.ValuationPortfolioName, operator: "contains" });
    }

    if (this.formData.controls.valuationPortfolio.value) {
      filter.filters.push({ field: 'ValuationProjectIdDescription', value: this.formData.controls.valuationPortfolio.value, operator: "contains" });
    }
  
    return filter;
  }

  /**
   * Creates the FormGroup
   * @param data
   * @returns
   */
  protected createFormGroup(data: any): UntypedFormGroup {
    return this.fb.group({
      reportId: new UntypedFormControl(data.reportId),
      valuer: new UntypedFormControl(data.valuer),
      community: new UntypedFormControl(data.community),
      street: new UntypedFormControl(data.street),
      valuationPortfolio: new UntypedFormControl(data.valuationPortfolio),
      puid: new UntypedFormControl(data.puid),
      includeFinalized: new UntypedFormControl(data.includeFinalized)
    });
  }

  /**
   * Resets the form
   */
  protected reset(): void {
    this.formData.reset();
  }

  /**
   * Initializes the form data
   * @returns
   */
  protected initFormData(): Promise<any> {
    return new Promise<any>((resolve) => {
      const values = {
        reportId: '',
        valuer: '' ,
        community: '',
        street: '',
        valuationPortfolio: '',
        puid: '' ,
        includeFinalized: true };
    
      resolve(values);
    });
  }
}
